import React from "react";
import I18n from "../../common/I18n";
import BaseList from "../BaseList";
import { checkIncomingDataType, getConfigKey } from "./helper";

class ModifiedActivitiesList extends BaseList {
  constructor(props) {
    super(props);
    this.columns = [
      {
        key: "setting_name",
        title: <b>{I18n.t("orgActivities.setting_name")}</b>,
        dataIndex: "setting_name",
        render: (data, record) => (
          <span>{getConfigKey(data)}</span>
        ),
        width: 140,
      },
      {
        key: "old_value",
        title: <b>{I18n.t("orgActivities.old_value")}</b>,
        dataIndex: "old_value",
        render: (data, record) => (
          <span>{checkIncomingDataType(data)}</span>
        ),
        width: 120,
      },
      {
        key: "new_value",
        title: <b>{I18n.t("orgActivities.new_value")}</b>,
        dataIndex: "new_value",
        render: (data, record) => {
          return (
            <span style={{ backgroundColor: !["N/A", "n/a", undefined, null, NaN, ""].includes(record?.old_value) ? "yellow" : null}}>
              {checkIncomingDataType(data)}
            </span>
          );
        },
        width: 120,
      },
    ];
  }
}
export default ModifiedActivitiesList;